import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import globalText from "../../../../utils/globalText";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const BeneficiaryTransactionFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { beneCreateTxnError } = useSelector(
    (state) => state.beneTransactionAccounts,
  );

  const sessionError = sessionStorage.getItem("bene_txn_error");
  const parsedSessionError = sessionError ? JSON.parse(sessionError) : null;
  const errorSource = parsedSessionError || beneCreateTxnError;

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) value.forEach(recurse);
      else if (typeof value === "object" && value !== null)
        Object.values(value).forEach(recurse);
      else if (typeof value === "string") messages.push(value);
    };

    recurse(errors);
    return messages;
  };

  const errorMessages = errorSource?.errors
    ? extractErrorMessages(errorSource.errors)
    : [];

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON,
        imgColor: "var(--negative-bg)",
        handleFunction: () => {
          sessionStorage.removeItem("bene_txn_error");
          navigate(
            "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
          );
        },
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          sessionStorage.removeItem("bene_txn_error");
          navigate("/beneficiary_transaction_dashboard");
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(disableSwitcher());
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="error"
      title={globalText?.BENEFICIARY_TRANSACTION_FAILED}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="Error details">
        <>
          {errorMessages.map((msg, index) => (
            <InfoCard
              key={index}
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: msg,
                  leftSubTitle: "Error message",
                },
              ]}
            />
          ))}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default BeneficiaryTransactionFailed;
